import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

class GenreCodeItem extends Component {
  state = {
    chkValue: false,
  };
  componentDidMount = () => {
    const { genreCode, chkCode } = this.props.childProps;
    //console.log(chkCode)
    //console.log(genreCode)

    const pos = chkCode.find((item, index) => {
      return genreCode.toString() === item;
    });

    if (pos !== undefined) {
      this.setState({
        chkValue: true,
      });
    }
  };

  _checkChange = (e) => {
    ////console.log(e)
    const { chkValue } = this.state;
    const { genreCode, genreCodeAdd, genreCodeDel } = this.props.childProps;

    if (!chkValue) {
      genreCodeAdd(genreCode);
      //TagSearchList 함수 Props로 받아서 "202007|202001" 형식으로 만들어 보낼것.
    } else {
      genreCodeDel(genreCode);
      //해당 코드 삭제.
    }

    this.setState({
      chkValue: !chkValue,
    });
  };
  render() {
    const { chkValue } = this.state;
    const { genreCode, genreName, init } = this.props.childProps;
    return (
      <Fragment>
        <dd>
          <div className="chek_group">
            <input
              name="선택"
              id={`checkbox_${genreCode}`}
              type="checkbox"
              value=""
              checked={init ? false : chkValue}
              className="checkbox_img"
              onChange={this._checkChange}
            />
            <label htmlFor={`checkbox_${genreCode}`}>{genreName}</label>
          </div>
        </dd>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(GenreCodeItem));
